<article>
  <h3 *ngIf="data.header" class="d-flex align-items-center">
    <span>{{ data.header }}</span>
  </h3>
  <mat-dialog-content>
    <div class="row content-msg">
      <div class="col-1">
        <mat-icon *ngIf="data.showIcon" class="warning-icon">warning</mat-icon>
      </div>
      <div class="col-11">
        <div
          *ngIf="data.message"
          class="d-flex align-items-center message"
          [innerHtml]="data.message"
        >
          {{ data.message }}
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="row">
      <div class="col">
        <mat-checkbox
          *ngIf="data.showDontAskAgain"
          class="action-check"
          [checked]="dontAskAgainVal"
          (change)="updatePromptPersist($event)"
        >
        </mat-checkbox>
        <span class="action-check-text"> Don't ask again</span>
      </div>
      <div class="col">
        <button
          mat-raised-button
          [color]="data.yesButtonColor"
          class="action-button"
          (click)="yesActionClick()"
        >
          {{ data.yesActionText }}
        </button>

        <button mat-button class="action-button" (click)="noActionClick()">
          {{ data.noActionText }}
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</article>
